<template>
    <div v-if="isCenter" class="wrap wrap--products">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <div class="board">
                    <div class="center-area">
                        <center-navigation v-if="isCenter" />
                        <div class="terms-container" style="margin-top:80px">
                            <h1 class="title">개인정보처리방침</h1>
                            <terms-component ref="top" code="top" mode="text" />
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
    <div v-else class="wrap wrap--sub">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <div class="contents">
                    <div class="terms-container">
                        <h1 class="title">개인정보처리방침</h1>
                        <terms-component ref="top" code="top" mode="text" />
                    </div>
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import TermsComponent from "@/components/client/terms/terms-component.vue";
import CenterNavigation from "@/components/client/center/center-navigation.vue";
export default {
    components: {
        MainHeader,
        MainFooter,
        TermsComponent,
        CenterNavigation,
    },
    computed: {
        isCenter() {
            return this.$route.path.includes("/center");
        },
    },
};
</script>
